import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField } from 'material-ui';

import Btn from '../../../components/Btn';
import '../../../grid.css';
import './nyserda.css';

class NYSERDA extends Component {
    toggleIsVisible() {
        const { setNYSERDAIsVisible, isVisible } = this.props;
        setNYSERDAIsVisible(!isVisible);
    }

    handleRebateChange(value) {
        const { setNYRebate } = this.props;
        setNYRebate(Number(value));
    }

    render() {
        const {
            nyRebate, isVisible, isLocked,
        } = this.props;

        return (
            <div>
                <Btn label="NYSERDA" onClick={(e, value) => this.toggleIsVisible(value)} />
                {isVisible ? (
                    <div className="row containerSGIP">
                        <div>
                            <div className="col span-1-of-4">
                                <TextField
                                    hintText="8.00"
                                    defaultValue={nyRebate}
                                    onChange={(e, value) =>
                                        this.handleRebateChange(value)}
                                    floatingLabelText="NYSERDA Rebate $/W"
                                    disabled={isLocked}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

NYSERDA.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    isLocked: PropTypes.bool.isRequired,
    setNYSERDAIsVisible: PropTypes.func.isRequired,
    nyRebate: PropTypes.number.isRequired,
    setNYRebate: PropTypes.func.isRequired,
};

NYSERDA.defaultProps = {};

export default NYSERDA;



// WEBPACK FOOTER //
// ./src/containers/Inputs/NYSERDA/NYSERDA.js